<script>
	import formBase from '@_system/components/base/form.vue'
	import matchbox from './box/matchbox.vue'
	import suppliergrouppurchaseBox from './box/suppliergrouppurchase.vue'
	
	export default {
		extends: formBase,
		name: 'purchaseForm',
		// render(h) {
		// 	this.$slots.plug = [ <div id = "purchaseWrite" > 同步采购信息 </div>,
		// 	]


		// 	return formBase.render.call(this, h)
		// },
		render(h) {
			this.$slots.plug = [ <div id = "purchaseWrite" > 同步采购信息 </div>, 
			<matchbox ref = "matchbox"
				onBack = {
					this.matchboxBack
				}
				onSubmit = {
					this.matchboxSubmit
				}
				onBoxdataload = {
					this.boxdataload
				}
				policyId = {
					this.policyId
				}
				/>,
				<suppliergrouppurchase-box sourceStoreUids={this.sourceStoreUids} ref = "suppliergrouppurchaseBox" onSubmit={this.suppliergrouppurchaseboxSubmit} />,
				this.customerloading?<div class="full" style="position: fixed;z-index:99999" v-loading={true} body={true} element-loading-text={this.loadingtext}></div>:''
			]


			return formBase.render.call(this, h)
		},
		props: {

		},
		data() {
			return {
				customerloading: false,
				loadingtext: '正在生成采购建议，请稍后...',
				policyId: 0,
				pchsStoreUid:0,
				sourceStoreUids: 0,
				currentPolicy: null,
			}

		},

		watch: {
			sourceStoreUids(val) {
				if (val) {
					if (this.fApi.el) {
						let $son_purchase_goods = this.fApi.el('$son_purchase_goods')
						$son_purchase_goods.store.box.add.setForeingKey({
							warehousewlnid: val
						})
					}
				}
			}
		},
		computed: {

		},
		created() {
			
			if (this.extra.componentname) {
				this.componentname = this.extra.componentname
			}
			if (this.extra.currentPolicy) {
				
				this.currentPolicy = this.extra.currentPolicy
				this.policyId = this.extra.currentPolicy.policyId
				this.sourceStoreUids = this.extra.currentPolicy.sourceStoreUids.replace(',', '')
			}
		},
		mounted() {
			this.extra.customertype = this.componentname ? this.componentname.replace('form', '') : null

		},
		destroyed() {

		},
		methods: {
			beforeFormCreate(res) {
				res.forEach((item) => {
					if (this.extra.customertype == 'emergent') {
						if (item.field == 'type') {
							item.value = 312
						}
						// 		if(item.field == '$son_purchase_goods'){
						// 			item.config.checkbox = true

						// 		}
					}

				})

			},

			regestEvent(rule, fApi) {
				// fApi.el('$son_purchase_goods').getGrid().loadData([[]]).then(()=>{

				// })

				let $son_purchase_goods = this.fApi.el('$son_purchase_goods')
				$son_purchase_goods.store.form = this
				fApi.mergeRule('$son_purchase_goods', {
					on: {
						importtemplate: this.purchaseGoodsImporttemplate,
						automatch: this.automatch,
					}
				})
				$son_purchase_goods.store.box.add.setForeingKey({
					warehousewlnid: this.sourceStoreUids
				})



				// if(!this.id){
				// 	$son_purchase_goods.store.box.add.setForeingKey({
				// 		policyId: this.policyId
				// 	})
				// }

				const button = document.getElementById('purchaseWrite');
				button.addEventListener('clickWithParams', () => {
					let data = localStorage.getItem('panelPchsAdvise');
					if (data) {
						data = JSON.parse(data)
						this.loading = true
						this.$api[this.name].getPurchaseGoods({
							data: data
						}).then((res) => {
							let data = this.fApi.el('$son_purchase_goods').getGrid().getTableData()
								.fullData
							data.forEach((item) => {
								this.fApi.el('$son_purchase_goods').getGrid().remove(item)
							})
							res.forEach((item) => {
								this.fApi.el('$son_purchase_goods').getGrid().insertAt(item)
							})
							this.loading = false
						}, () => {
							this.loading = false
						})

					}
				});

				let type = this.$systemMethods.getEmunValue('policytype', this.fApi.getValue('type'))
				this.fApi.setValue('name', this.getFormattedTime() + '【' + type + '】')
				this.fApi.setValue('policyId', this.policyId)
				this.fApi.setValue('sourceStoreUids', this.sourceStoreUids)
				let warehouse = window.systemData.warehouse.find((item)=>{
					return item.wlnid == this.sourceStoreUids
				})
				if(warehouse){
					this.fApi.setValue('warehouseid', warehouse.id)
				}
				
			},
			afterGet(e) {
				this.policyId = e.policyId
				this.sourceStoreUids = e.sourceStoreUids
			},
			boxdataload() {

			},
			
			suppliergrouppurchase_purchase_goods() {
				this.$refs.suppliergrouppurchaseBox.initList()
				this.$nextTick(()=>{
					this.$refs.suppliergrouppurchaseBox.box.alertBox()
				})
				
			},
			suppliergrouppurchaseboxSubmit(e) {
				this.loading = true
				this.$api[this.name].createpurchasegoods({data:e.data}).then((res) => {
					this.fApi.el('$son_purchase_goods').getGrid().insert(res)
					this.loading = false
				}, () => {
					this.loading = false
				})
			},
			automatch() {
				this.match().then(() => {
					this.$refs.matchbox.box.alertBox()
				})
			},
			matchboxBack() {
				this.$refs.matchbox.box.close()
			},
			matchboxSubmit(e) {
				let $son_purchase_goods = this.fApi.el('$son_purchase_goods')
				$son_purchase_goods.add(e)
			},
			tableInsert(e) {
				if (e.moduleName == 'purchase_goods') {
					e.obj.stock = e.data.quantity
					e.obj.warehouseid = e.data.warehouseid
					e.obj.requirement = e.data.requirement
					e.obj.underway = e.data.underway_quantity
					if (this.extra.customertype == 'emergent') {
						e.obj.policytype = 312
					} else {
						e.obj.policytype = 311
					}
					if (e.data.lock_quantity == undefined) {
						this.loading = true
						this.$api.purchase.getStock({
							id: e.data.id
						}).then((res) => {
							this.loading = false
							res.forEach((item)=>{
								if(item.warehousewlnid == this.sourceStoreUids){
									let data = e.table.getTableData().fullData
									data.forEach((d)=>{
										if(d.goodsid == item.goodsid){
											d.stock = item.quantity
											d.requirement = item.lock_quantity
											d.underway = item.underway_quantity
										}

									})
								}
							})
							
						})
					}
				}
			},
			purchaseGoodsImporttemplate() {
				this.$store.commit('getTemplate', 'purchase_goods')
			},
			getFormattedTime() {
				let now = new Date();
				let year = now.getFullYear().toString().slice(-2); // 获取年份后两位
				let month = String(now.getMonth() + 1).padStart(2, '0'); // 月份从0开始，所以加1
				let day = String(now.getDate()).padStart(2, '0');
				let hour = String(now.getHours()).padStart(2, '0');
				let minute = String(now.getMinutes()).padStart(2, '0');
				let second = String(now.getSeconds()).padStart(2, '0');
				return `${year}${month}${day}${hour}${minute}${second}`;
			},

			export () {
				alert(123)
			},


			match() {
				this.loadingtext = '正在生成采购建议，请稍后...'
				return new Promise((reslove) => {
					this.createPolicySuggest().then(() => {
						this.loadingtext = '正在组装数据...'
						this.queryIntelligencePchs().then(() => {
							this.customerloading = false
							reslove()
						})
					}, (e) => {
						if (e) {
							this.$message.error(e)
						}
					})
				})

			},
			createPolicySuggest() {
				let index = 1
				return new Promise((reslove, reject) => {
					this.$api.purchase.buildIntelPchsAdvise({
						sourceStoreUids: this.sourceStoreUids,
						policyId: this.policyId
					}).then((res) => {
						if (res == 1) {
							reslove()
						} else {
							this.customerloading = true
							let handle = setInterval(() => {
								this.loadingtext = '正在生成采购建议，请稍后...' + (index * 2) + 's'
								index++
								this.$api.purchase.getLongTask().then((res) => {
									if (res) {
										clearInterval(handle)
										reslove(res)
									}
									if (index >= 30) {
										clearInterval(handle)
										this.customerloading = false
										reject('生成失败，请重试')
									}
								}, () => {
									clearInterval(handle)
									this.customerloading = false
									reject('生成失败，请重试')

								})
							}, 2000)
						}
					}, () => {
						reject()
					})
				})
			},
			queryIntelligencePchs() {
				let type = this.$systemMethods.getEmunValue('policytype', this.fApi.getValue('type'))
				return new Promise((reslove) => {
					this.$api.purchase.queryIntelligencePchs({
						policyId: this.policyId,
						pchsStoreUid: this.sourceStoreUids,
						policyName: type
					}).then(() => {
						reslove()
					})
				})

			},
			importMethod(e) {
				let file = e.file
				let formData = new FormData()
				formData.append('excle', file)
				return new Promise((resolve) => {
					this.loading = true
					this.$api[this.name].goodsimport(this.id, formData).then((res) => {
						// this.fApi.el('$son_purchase_goods').getGrid().loadData(res).then(()=>{
						// 	console.log(this.fApi.el('$son_purchase_goods').getGrid().getTableData())
						// })
						//console.log(this.fApi.el('$son_purchase_goods'), res)

						this.fApi.el('$son_purchase_goods').getGrid().insert(res)
						resolve()
						this.loading = false
					}, () => {
						this.loading = false
						resolve()

					})
				})
			},
		},
		components: {
			matchbox,
			suppliergrouppurchaseBox
		}
	}
</script>